import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/start-analysis.png")